App.ClientChatComponent = Em.Component.extend
  classNames: [ 'client-chat' ]

  messages: null
  currentGroupDate: ''
  showFixedGroupDate: false
  messageValue: ''
  isLoading: false

  singleChannel: Em.computed.equal('client.communication_channels.length', 1)

  mappedChannels: (->
    channels = @get('client.communication_channels')
    return null unless channels
    mappedChannels = channels.map (channel) =>
      id: channel
      text: Em.I18n.t "communication_channels.kinds.#{channel}"
      iconPath: "./images/#{channel}-icon.svg"
    mappedChannels
  ).property('client.communication_channels')

  didInsertElement: ->
    messages = @get('messages')
    return unless messages
    return unless messages.length 
    @set('currentGroupDate', messages.get(0).date)
    @send('readAllMessages')


  selectedChannel: (->
    channels = @get('mappedChannels')
    return null unless channels
    channels.get(0)
  ).property('mappedChannels.@each', 'mappedChannels')

  
  canSendMesssage: (->
    @get('client.communication_channels').length && !@get('isLoading')
  ).property('client.communication_channels', 'isLoading')

  disabledSendMessage: (->
    !@get('canSendMesssage') || @get('isLoading')
  ).property('canSendMesssage', 'isLoading')

  disabledSendButton: Em.computed.not('messageValue.length')

  sendMessageText: (->
    Em.I18n.t "communication_channels.chats.#{if @get('canSendMesssage') then 'can_send' else 'disabled'}"
  ).property('canSendMesssage')

  actions:
    loadMore: -> 
      @sendAction('onLoadMore')
      false

    onScroll: (target) ->
      return unless target
      scrollTop = target.scrollTop
      @set('showFixedGroupDate', scrollTop != 0)

      groups = target.querySelectorAll('.group')
      return unless groups.length > 0

      # Найти последнюю видимую группу
      visibleGroup = null
      Array.from(groups).forEach (group) ->
        if group.offsetTop <= scrollTop + target.offsetHeight / 2
          visibleGroup = group

      # Обновить `currentGroupDate`, если группа изменилась
      if visibleGroup?
        groupDate = visibleGroup.getAttribute('data-group')
        if groupDate != @get('currentGroupDate')
          @set('currentGroupDate', groupDate)

    sendMessage: ->
      return if @get('disabledSendButton')
      client = @get('client')
      return unless client
      @set('isLoading', true)
      client.nonRESTAction('POST', 'client_messages', {
        text: @get('messageValue')
        channel_kind: @get('selectedChannel.id')
      }).then (data) =>
        @set('isLoading', false)
        @set('messageValue', '')
      .finally =>
        @set('isLoading', false)

    readAllMessages: ->
      client = @get('client')
      return unless client
      @set('isLoading', true)
      client.nonRESTAction('PATCH', 'client_messages/mark_read').then () =>
        @set('isLoading', false)
        @sendAction('onReadAllMessages')
      .finally =>
        @set('isLoading', false)

    checkIfEnter: (e) ->
      console.log(e)
      false

